import { Reveal, Label } from "./Reveal";

export const About = ({ t }) => {
  const a = t.about;

  return (
    <section id="about" data-testid="about-section" className="bg-white py-24 lg:py-36">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-5">
          <Reveal><Label>{a.label}</Label></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-4xl leading-tight text-[#0F2137] md:text-5xl">{a.title}</h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 font-mono text-xs uppercase tracking-[0.18em] text-slate-500">{a.caption}</p>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal><p className="font-serif text-2xl leading-snug text-[#0F2137] md:text-[1.7rem]">{a.p1}</p></Reveal>
          <Reveal delay={0.1}><p className="mt-6 text-base leading-relaxed text-slate-600 md:text-lg">{a.p2}</p></Reveal>
          <div className="mt-14 border-t border-slate-300">
            {a.values.map((v, i) => (
              <Reveal key={v.k} delay={i * 0.08}>
                <div data-testid={`about-value-${i}`} className="grid grid-cols-12 gap-4 border-b border-slate-200 py-6">
                  <span className="col-span-2 font-mono text-xs text-slate-500 pt-1.5">0{i + 1}</span>
                  <span className="col-span-10 sm:col-span-4 font-serif text-xl text-[#0F2137]">{v.k}</span>
                  <span className="col-span-10 col-start-3 sm:col-span-6 text-sm leading-relaxed text-slate-600">{v.v}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
